import { useTheme } from '@mui/material/styles'
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import InfoTooltip from '../../../components/Tooltip/InfoTooltip'
import React from 'react'
import NumberFunctions from '../../../core/functions/NumberFunctions'
import { TBalanceCurrency } from '../../../core/types/Tenant'

export const BalanceLightCard = ({
  balance,
  title = 'Saldo total',
  tooltip,
  action,
  currency = 'brl',
}: {
  balance: number
  title?: string | React.ReactNode
  tooltip?: React.ReactNode
  action?: React.ReactNode
  currency?: TBalanceCurrency
}) => {
  const theme = useTheme()

  return (
    <Box
      display="flex"
      width={{ xs: '100%', sm: '50%' }}
      justifyContent="center"
      alignItems="flex-start"
      sx={{ p: 2 }}
    >
      <List sx={{ py: 0 }}>
        <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
          <ListItemText
            sx={{
              py: 0,
              mt: 0.45,
              mb: 0.45,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
            }}
            primary={
              <Typography
                variant="subtitle2"
                sx={{
                  size: '12px',
                  lineHeight: '16px',
                  alignContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  color: theme.palette.grey[900],
                  mt: 0.25,
                }}
              >
                {title}
              </Typography>
            }
            secondary={
              <Stack direction="column" alignItems="center" gap={0.5}>
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <Typography variant="h5" color={theme.palette.grey[900]}>
                    {NumberFunctions.formatMoneyDefault(balance, currency)}
                  </Typography>
                  {tooltip && <InfoTooltip title={tooltip} />}
                </Stack>

                {action && <Box mt={0.5}>{action}</Box>}
              </Stack>
            }
          />
        </ListItem>
      </List>
    </Box>
  )
}
